import styles from './section-header.module.scss';

const SectionHeader = ({ lineColor, title, description, width, paddingBotton, lineWidth, titleFontSize, descriptionFontSize, descriptionMaxWidth }) => {
  return (
    <div className={styles.section} style={{paddingBottom: paddingBotton}}>
      <div 
        className={styles.topLine} 
        style={{backgroundColor: lineColor, borderRadius: '10px', width: lineWidth, height: '4px'}}
      />
      <h2 className={styles.title} style={{ fontSize: width >= 568 && width  < 992 ? '4.23vw' : titleFontSize, padding: '0 10px', marginBottom: width <= 992 ? '4.10vw': ''}}>{title}</h2>
      {description && <p className={styles.description} style={{ fontSize: width >= 568  && width  < 992 ? '3.17vw' : descriptionFontSize, maxWidth: descriptionMaxWidth}}>{description}</p>}
    </div>
  );
};

export default SectionHeader;
